import React from "react";
import Drawer from "../components/Drawer";
import BottomNavBar from "../components/BottomNavBar";
import PricingCard from "../components/PricingCard";
import Box from "@mui/material/Box";
import { Container } from "@mui/material";

function Dashboard() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
      }}
    >
      <Drawer headerTitle="My Social Business Card" />
      
      <Container sx={{ mt: 2, mb: 2, flex: 1, overflow: 'auto' }}>
        <PricingCard />
      </Container>

      <BottomNavBar />
    </Box>
  );
}

export default Dashboard;
